import React from 'react';
//import styles from './SenseiSectionJoinNow.module.sass'
//import cn from "classnames";
import { Link, useNavigate } from "react-router-dom";
import majesticHotelExteriorJpg from '../../../assets/images/properties/Majestic-Hotel/Majestic-Hotel-Exterior.jpg';
//import senseiLabsBuildingJpg from '../../../assets/images/Sensei-Labs/WEBoffice-building-2023-11-27-05-34-41-utc.jpg';
import { NAMES_CONSTANTS } from '../../../constants';

const SenseiSectionJoinNow = (props) => {

    const navigate = useNavigate();
    
    let userAccessToken = localStorage.getItem(NAMES_CONSTANTS.USER_ACCESS_TOKEN);
    console.debug('SenseiSectionJoinNow: userAccessToken = ', userAccessToken);

    return (
        <section
            className = 'sensei sensei-dark sensei-exclusive'
            style = {{
                //  backgroundImage: 'url(images/backgrounds/what-is-realsplit-background-275x183.jpg)'
                //backgroundImage: 'url(../../../assets/images/Sensei-Labs/WEBoffice-building-2023-11-27-05-34-41-utc.jpg)'
                //backgroundImage: 'url(images/Sensei-Labs/WEBoffice-building-2023-11-27-05-34-41-utc.jpg)'
                //, backgroundPosition: 'left 0px bottom -100px'
                //, backgroundPosition: 'center center'
                //, backgroundRepeat: 'no-repeat'
                //, backgroundSize: 'cover'
                //backgroundColor: '#233F79'
                //, maxWidth: 'var(--site-width)'
                //, maxWidth: '1500px'
                //, margin: 'auto'
                //paddingTop: '80px'
            }}
            >

            <div
                //id = 'what-is-realsplit-container'
                //className = 'container'
                //className = 'flex-container max-width'
                className = 'site-max-width'
                style = {{
                    //maxWidth: 'var(--site-width)'
                    //maxWidth: '1350px'
                    //, flexWrap: 'wrap'
                    margin: 'auto'
                    //, marginLeft: '0'
                    //, textAlign: 'left'
                    //, width: '1500px'
                    //,  backgroundImage: 'url(images/backgrounds/what-is-realsplit-background.jpg)'
                    //, backgroundPosition: 'center'
                    //, backgroundRepeat: 'no-repeat'
                    //, backgroundImage: 'url(images/backgrounds/what-is-realsplit-background-275x183.jpg), url(images/backgrounds/what-is-realsplit-background-striped.jpg)'
                    //, backgroundImage: 'url(images/deals/Hillcrest/Hillcrest-pool.png), url(images/backgrounds/what-is-realsplit-background-striped.jpg)'
                    //, backgroundImage: 'url(images/properties/Majestic-Hotel/Majestic-Hotel-Exterior.jpg), url(images/backgrounds/what-is-realsplit-background-striped.jpg)'
                    //, backgroundImage: 'url(/assets/images/Sensei-Labs/WEBoffice-building-2023-11-27-05-34-41-utc.jpg)'
                    //, backgroundPosition: 'left 0px bottom 100px, right 150px bottom 0px'
                    //, backgroundRepeat: 'no-repeat, no-repeat'
                    //, backgroundSize: '650px, 400px'
                    //, paddingBottom: '250px'
                }}
                >

                

                <div
                    style = {{
                        //  margin: 'auto'
                        //, marginLeft: '0'
                        //, textAlign: 'left'
                        //maxWidth: '710px'
                        margin: 'auto'
                        , textAlign: 'center'
                        , padding: '50px 0px'
                        , display: 'flex'
                        //, display: 'inline-flex'
                        , flexWrap: 'wrap'
                        , flexDirection: 'row'
                        //, alignItems: 'center'
                        , alignItems: 'flex-start'
                        , justifyContent: 'center'
                        , gap: '30px'
                    }}>

                    <div>
                        <img
                            className = 'realsplit-building'
                            src = '/images/Sensei-Labs/RealSplit-New-Logo-Building-Only_512x512.png'
                            //style = {{
                            //    maxHeight: '260px'
                                //, maxWidth: '50px'
                            //}}
                            />
                    </div>

                    <div
                        style = {{
                            //  margin: 'auto'
                            //, marginLeft: '0'
                            //, textAlign: 'left'
                            maxWidth: '710px'
                            //, margin: 'auto'
                            //, textAlign: 'center'
                            //, padding: '50px 0px'
                        }}
                        >
                        <h2
                            //className = { styles.sectionTitle }
                            className = 'baskervville-regular'
                            style = {{
                                //padding: '50px 0px 50px 0px'
                                //textAlign: 'center'
                                textAlign: 'left'
                                //display: 'inline'
                                //, margin: '0'
                                //, padding: '20px 0px 30px 0px'
                                //, color: 'var(--color-gray-800, #343A40)'
                                //, textAlign: 'center'
                                //, fontFamily: 'Roboto Serif'
                                //, fontStyle: 'italic'
                                //, fontWeight: '500'
                                //, lineHeight: '120%'
                                //, marginRight: '50px'
                                //, fontSize: '65px'
                                //, fontWeight: '550'
                                //, lineHeight: '60px'
                            }}
                            >
                            Exclusive private market equity, & complete profit sharing.
                        </h2>

                        <div
                            className = 'large'
                            style = {{
                            //    marginBottom: '30px'
                            //    , marginTop: '10px'
                                //fontFamily: '"Baskervville", serif'
                                textAlign: 'left'
                                , fontSize: '24px'
                                , lineHeight: '120%'
                                , padding: '10px 0px 10px 0px'
                                , color: '#fff'
                                //, maxWidth: '850px'
                            }}
                            >
                            Finally the preferred asset class of institutions and sophisticated,
                            wealthy investors is available to any accredited investor.

                            <div
                                to="/search/all"
                                target = "_blank"
                                style = {{
                                    padding: "30px 0px 0px 0px"
                                    , textAlign: 'center'
                                    , margin: 'auto'
                                    , marginLeft: '-20px'
                                }}
                                >

                                {/*
                                <Link
                                    to = "/search/all"
                                    target = "_blank"
                                    >
                                */}
                                    <button
                                        type = 'button'
                                        //className = 'theme-success large'
                                        className = 'theme-sensei'
                                        onClick = { (event) => {
                                            if (!userAccessToken) {
                                                props.loginRegisterFunctions.clickRegister(event);
                                                return;
                                            } else {
                                                //window.open('https://realsplit.deal.tribexa.com/deal/create-investment', '_blank').focus();
                                                navigate('/search/all')
                                            }
                                        }}
                                        >Invest Now</button>
                                {/*
                                </Link>
                                */}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default SenseiSectionJoinNow;
